<template>
    <div id="events">
        <div v-if="loading" id="fullscreen-loader">
            <img src="@/assets/logo.png"/>
        </div>
        <navbar :transparent="false" position="fixed">
            <div class="navbar-wrapper">
                <router-link class="navbar-brand" :to="{ name: 'events' }">
                    {{ $store.state.props.appName }}
                </router-link>
            </div>
            <template slot="navbar-menu">
                <ul class="navbar-nav">
                    <li class="nav-item" v-if="user.admin">
                        <router-link class="nav-link" :to="{ name: 'general-settings' }">
                            Settings
                        </router-link>
                    </li>
                    <drop-down
                        tag="li"
                        position="right"
                        class="nav-item"
                        icon="now-ui-icons users_single-02">
                            <router-link v-if="$store.state.user.admin" :to="{ name: 'change-password' }" class="dropdown-item">Change Password</router-link>
                            <a class="dropdown-item" href="#" @click.prevent="logout()">Logout</a>
                    </drop-down>
                </ul>
            </template>
        </navbar>

        <div class="container-fluid">
            <fade-transition :duration="200" mode="out-in">
                <router-view/>
            </fade-transition>
        </div>
    </div>
</template>

<script>
import { FadeTransition } from 'vue2-transitions'
import { Navbar } from '@/components/now-ui'
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState([
            'user'
        ])
    },
    components: {
        FadeTransition,
        Navbar
    },
    data () {
        return {
            loading: true
        }
    },
    mounted () {
        if( !this.user.admin){
            this.$router.push('/events/')
        }
        this.getUser()
    },
    methods: {
        getUser: async function () {
            this.loading = true
            try {
                await this.$store.dispatch('getUser')
            } catch (e) {
                this.$notify({ type: 'danger', message: 'Unauthorized!' })
                this.$router.push({ name: 'login' })
            }
            this.loading = false
        },
        logout: function () {
            this.$store.dispatch('logout')
            this.$router.push({ name: 'login' })
        }
    }
};
</script>

<style lang="sass">
    @import '../../assets/css/variables'

    #events
        background-color: $bodyBg
</style>